import {getElement} from "./utils/utils";
import {getPosts} from "./utils/getData";

const initLoadMorePosts = () => {
    const loadMoreBtn = getElement('.js-load-more-posts');
    const postsContainer = getElement('.js-posts');
    const {posts_per_page} = smkHelper

    if (!loadMoreBtn || !postsContainer) {
        return;
    }

    let page = 1;

    loadMoreBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        const postType = loadMoreBtn.getAttribute('data-post-type')
        const currentPage = loadMoreBtn.getAttribute('data-current-page')
        const maxPage = loadMoreBtn.getAttribute('data-max-page')
        loadMoreBtn.disabled = true;
        page++;

        loadMoreBtn.setAttribute('data-current-page', page)

        if (page === parseInt(maxPage)) {
            setTimeout(function () {
                loadMoreBtn.style.display = 'none';
            }, 300)
        }

        try {
            const response = await getPosts(page, postType);
            if (response && response.status === 200) {
                const data = await response.text();

                postsContainer.insertAdjacentHTML('beforeend', data);

                // Check if there are no more posts
                if (!data.trim()) {
                    loadMoreBtn.style.display = 'none';
                }
                loadMoreBtn.disabled = false;
            } else {
                console.error('Failed to load more posts:', response.status);
                loadMoreBtn.style.display = 'none';
            }
        } catch (error) {
            console.error('Error handling the click event:', error);
            loadMoreBtn.style.display = 'none';
        }
    });
};

export { initLoadMorePosts };
